export default {
    root: ({ props, context, parent, instance }) => ({
        class: [
            'input-otp-root',
            'font-inter',
            {
                'input-otp-xxs': props.size === 'xxs',
                'input-otp-xs': props.size === 'xs',
                'input-otp-sm': props.size === 'sm',
                'input-otp-md': props.size === 'md',
                'input-otp-lg': props.size === 'lg',
            }
        ],
    }),
};